import appStore from "../../assets/appstore.png";
import googlePlay from "../../assets/googleplay.png";
import image from "../../assets/svgs/clay_phone_13_pro_max_mockup.png";
import "./DownloadApp.scss";

function DownloadApp() {
  return (
    <div className="download-app-wrapper" id="app-section">
      <div className="container">
        <div className="download-app-content">
          <div className="download-app-text">
            <h5 className="download-app--title">تحميل التطبيق</h5>
            <h3 className="download-app--desc">
              هيا قم بتحميل التطبيق واحصل على أفضل خدمات تمويل السيارات
            </h3>
            <div className="app-link-holder">
              <a href="">
                <img src={appStore} alt="app store" />
              </a>
              <a href="">
                <img src={googlePlay} alt="google play" />
              </a>
            </div>
          </div>
          <div className="app-hero-img">
            <img
              src={image}
              alt=""
              className=" rtl:[transform:rotateY(180deg)]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DownloadApp;
